<form (ngSubmit)="verifyAddress()" [formGroup]="addressForm">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>
          <span class="label-content required mandatory">{{
            'addressForm.firstName.label' | cxTranslate
          }}</span>
          <input class="form-control" type="text" formControlName="firstName" maxlength="70" />
          <cx-form-errors [control]="addressForm.get('firstName')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>
          <span class="label-content required mandatory">{{'addressForm.address1' | cxTranslate }}</span>
          <input type="text" class="form-control" formControlName="line1" maxlength="70" />
          <cx-form-errors [control]="addressForm.get('line1')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content required mandatory">{{ 'addressForm.email.label' | cxTranslate }}</span>
          <input [readOnly]="true" type="email" class="form-control" formControlName="email" />
        </label>
      </div>
    </div>
    <div class="col-md-6 address-phone">
      <div class="form-group">
        <label>
          <span class="label-content required mandatory">{{ 'addressForm.phoneNumber.label' | cxTranslate }}</span>
          <input type="text" class="form-control" formControlName="phone" />
          <cx-form-errors [control]="addressForm.get('phone')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label>
        <span class="label-content required mandatory">{{ 'addressForm.zipCode.label' | cxTranslate }}</span>
        <input type="text" class="form-control" formControlName="postalCode" (keypress)="validatePostalCode()"
          (focusout)="validatePostalCode()" />
        <cx-form-errors [control]="addressForm.get('postalCode')"></cx-form-errors>
      </label>
    </div>
    <div class="form-group col-md-6 address-town">
      <label>
        <span class="label-content required mandatory">{{ 'addressForm.city.label' | cxTranslate }}</span>
        <input type="text" class="form-control" formControlName="town" maxlength="35" />
        <cx-form-errors [control]="addressForm.get('town')"></cx-form-errors>
      </label>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6 mb-3 address-country" formGroupName="country">
      @if (countries$ | async; as countries) {
        @if (countries.length !== 0) {
          <div>
            <label class="select-label" aria-required="true">
              <span class="label-content required">{{ 'addressForm.country' | cxTranslate }}</span>
              <select formControlName="isocode" class="form-control" readonly="true" [attr.disabled]="true">
                <option selected disabled value="">
                  {{ 'updateProfileForm.country.label' | cxTranslate }}
                </option>
                @for (country of countries; track country) {
                  <option class="option-select" [value]="country.isocode">
                    {{ country.name }}
                  </option>
                }
              </select>
              <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
              <cx-form-errors [control]="addressForm.get('country.isocode')"></cx-form-errors>
            </label>
          </div>
        }
      }
    </div>

    <!--        <div class="form-group col-md-6 p-0 mb-3 address-country" formGroupName="country">-->
    <!--          <ng-container *ngIf="countries$ | async as countries">-->
    <!--            <div *ngIf="countries.length !== 0">-->
    <!--              <label aria-required="true">-->
    <!--              <span class="label-content required">{{-->
    <!--                'addressForm.country' | cxTranslate-->
  <!--                }}</span>-->
  <!--                <ng-select-->
  <!--                  class="country-select" [readonly]="true"-->
  <!--                  formControlName="isocode"-->
  <!--                  [searchable]="true"-->
  <!--                  [clearable]="false"-->
  <!--                  [items]="countries"-->
  <!--                  bindLabel="name"-->
  <!--                  bindValue="isocode"-->
  <!--                  (change)="countrySelected($event)"-->
  <!--                >-->
<!--                </ng-select>-->
<!--                <cx-form-errors-->
<!--                  [control]="addressForm.get('country.isocode')"-->
<!--                ></cx-form-errors>-->
<!--              </label>-->
<!--            </div>-->
<!--          </ng-container>-->
<!--        </div>-->


<div class="form-group col-md-6 address-region" formGroupName="region">
  @if (regions$ | async; as regions) {
    <div>
      @if (regions.length !== 0) {
        <div>
          <label aria-required="true">
            <span class="label-content required mandatory">{{ 'addressForm.state' | cxTranslate }}</span>
            <select formControlName="isocode" class="form-control filter-select" (change)="validatePostalCode()">
              <option selected disabled value="">
                {{ 'addressForm.state' | cxTranslate }}
              </option>
              @for (region of regions; track region) {
                <option class="option-select" [value]="region.isocode">
                  {{ region.name }}
                </option>
              }
            </select>
            <!--            <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
            <cx-form-errors [control]="addressForm.get('region.isocode')"></cx-form-errors>
          </label>
        </div>
      }
    </div>
  }
</div>
</div>

<!--        <ng-container *ngIf="regions$ | async as regions" formGroupName="region" >-->
<!--          <ng-container *ngIf="regions.length !== 0">-->
<!--            <div class="form-group col-md-6 pr-0 address-region">-->
<!--              <label aria-required>-->
<!--                <span class="label-content required mandatory">{{ 'addressForm.state' | cxTranslate }}</span>-->
<!--                <ng-select-->
<!--                  (change)="validatePostalCode()"-->
<!--                  class="region-select"-->
<!--                  formControlName="isocode"-->
<!--                  [searchable]="true"-->
<!--                  [clearable]="false"-->
<!--                  [items]="regions"-->
<!--                  bindLabel="{{ regions[0].name ? 'name' : 'isocode' }}"-->
<!--                  bindValue="{{ regions[0].name ? 'isocode' : 'region' }}"-->
<!--                >-->
<!--                </ng-select>-->
<!--                <cx-form-errors-->
<!--                  [control]="addressForm.get('region.isocode')"-->
<!--                ></cx-form-errors>-->
<!--              </label>-->
<!--            </div>-->
<!--          </ng-container>-->
<!--        </ng-container>-->

<div class="row">
  <div class="col-md-12">
    @if ((addresses$ | async)?.length && setAsDefaultField) {
      <div class="form-group">
        <div class="form-check">
          <label class="checkbox">
            <input type="checkbox" class="form-check-input" formControlName="defaultAddress"
              (change)="toggleDefaultAddress()" />
            <span class="form-check-label">
              {{ 'addressForm.setAsDefault' | cxTranslate }}
            </span>
          </label>
        </div>
      </div>
    }
  </div>
</div>

<div class="row">
  @if (showCancelBtn) {
    <div class="col-md-12 col-lg-6 mt-4 btn-container">
      <a class="btn btn-white btn-block" (click)="back()">
        {{ 'common.back' | cxTranslate }}
      </a>
    </div>
  }
  <div class="col-md-12 col-lg-6 mt-4 btn-continue">
    <button class="btn btn-block btn-black" type="button" (click)="onSubmit()">
      {{ actionBtnLabel || ('common.continue' | cxTranslate) }}
    </button>
  </div>
</div>
</form>